import React, { useState, useEffect } from "react";
import { Table } from "antd";
import {
  User1,
  User2,
  User3,
  User4,
  User5,
  User6,
  User7,
  User8,
  User9,
  User10,
  User11,
  User12,
} from "../../../../Routes/ImagePath";
import { Link } from "react-router-dom";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";

import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

import AuthUser from "../../../../components/AuthUser";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "../../../../components/Spinner";
import CertificadoEditModal from "../../../../components/Administration/employees/CertificadoEditModal";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const CertificadoTable = ({ certificados, colaboradores }) => {
  const { t } = useTranslation();

  const [certificado, setcertificado] = useState();
  const [certificadoselecionado, setcertificadoSelecionado] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const { http, url_root, user_permissoes, verificarPermissao, getMissao } = AuthUser();

  // State to track whether the "checkgeral" checkbox is checked
  const [loading, setLoading] = useState(false);

  const [selectedUserIds, setSelectedUserIds] = useState([]);

  useEffect(() => {
    setcertificado(certificados);
  }, [certificados]);

  const handleSubmissionSuccess = (certificados) => {
    setcertificado(certificados);
  };

  const chamarModalEliminar = (idSelecionado) => {
    setcertificadoSelecionado(idSelecionado);
    const editButton = document.getElementById("triggerModalEliminar");
    if (editButton) {
      editButton.click();
    }
  };

  const chamarModalEdit = (idSelecionado) => {
    setcertificadoSelecionado(idSelecionado);
    const editButton = document.getElementById("triggerModalEdit");
    if (editButton) {
      editButton.click();
    }
  };

  const handleAtivarDesativar = async (id, newState) => {
    if (verificarPermissao("CARGO", "ativar")) {
      try {
        setLoading(true);

        const formData = new FormData();
        formData.append("id", id);
        formData.append("estado", newState == 1 ? 1 : 0);

        const response = await http.post(
          "/certificado-ativate-desactivate-single",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        setLoading(false);
        setcertificado(response.data.certificados);
      } catch (error) {
        console.error(error);

        setLoading(false);

        toast.error(
          "Ocorreu um erro ao atualizar o estado do usuário. Por favor, tente novamente mais tarde.",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      } finally {
        setLoading(false);
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const today = new Date();

  const calculateExpirationInfo = (trainingExpiration) => {
    const expirationDate = new Date(trainingExpiration);
    expirationDate.setFullYear(expirationDate.getFullYear());

    const timeDiff = expirationDate.getTime() - today.getTime();
    const daysToExpire = Math.ceil(timeDiff / (1000 * 3600 * 24));

    const status =
      daysToExpire > 0 && daysToExpire <= 90
        ? "Prestes a expirar"
        : daysToExpire > 0
        ? "Valido"
        : "Expirado";

    return { daysToExpire, status };
  };

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (text, record, index) => index + 1,
    },
    {
      title: t("Colaborador"),
      dataIndex: "sigla",
      render: (text, record) => (
        <div
          className="d-flex align-items-center p-2 mb-2"
          style={{
            borderRadius: "8px",
            gap: "10px",
          }}
        >
          <div
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              backgroundColor: "#dee2e6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "20px",
            }}
          >
            <img
              src={url_root + "/storage/" + record?.formando?.fotografia}
              className="avatar rounded-circle"
              width={32}
              height={32}
              alt=""
            />
          </div>
          <div style={{ flexGrow: 1 }}>
            <div style={{ fontWeight: "bold", color: "#888" }}>
              {record?.formando?.name}
            </div>
            <div style={{ fontSize: "12px", color: "#6c757d" }}>
              {record?.formando?.cargo?.designacao}
            </div>
          </div>
        </div>
      ),
      sorter: (a, b) => a.sigla.length - b.sigla.length,
    },
    {
      title: "Certificação",
      dataIndex: "sigla",
      render: (text, record) => (
        <div
          className="d-flex align-items-center p-2 mb-2"
          style={{
            borderRadius: "8px",
            gap: "10px",
          }}
        >
          <div
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "20%",
              backgroundColor: "#dee2e6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "20px",
            }}
          >
            <img
              src={url_root + "/storage/cursos/" + record?.curso?.imagem}
              className="avatar rounded-square"
              width={32}
              height={32}
              alt=""
            />
          </div>
          <div style={{ flexGrow: 1 }}>
            <div style={{ fontWeight: "bold", color: "#888" }}>
              {record?.curso?.designacao}
            </div>
            <div style={{ fontSize: "12px", color: "#6c757d" }}>
              {" Emissão: "}
              {new Date(record.data_emissao).toLocaleDateString()}
              {" - Expira: "}
              {new Date(record.data_expiracao).toLocaleDateString()}
            </div>
          </div>

          <div className="d-flex align-items-center gap-3">
            <a
              href={url_root + "/storage/certificados/" + record?.ficheiro}
              target="blank"
            >
              <i
                width="40"
                height="40"
                className="fa fa-file-pdf"
                alt="File icon"
              ></i>
            </a>
          </div>
        </div>
      ),
      sorter: (a, b) => a.sigla.length - b.sigla.length,
    },
    {
      title: "Nivel",
      dataIndex: "nivel",
      render: (text, record) => (
        <>
          <span>
            {record.curso?.nivel == 1
              ? "Básico"
              : record.curso?.nivel == 2
              ? "Intermédio"
              : record.curso?.nivel == 3
              ? "Avançado"
              : "Padrão"}
          </span>
        </>
      ),
      sorter: (a, b) => a.nivel.length - b.nivel.length,
    },
    {
      title: "Duração",
      dataIndex: "duracao",
      render: (text, record) => (
        <>
          <span>
            {record.curso?.expira == 1
              ? record.curso?.expiracao +
                " " +
                (record.curso?.expira_unidade == 1 ? "Mes(es)" : "Ano(s)")
              : "Não Expira"}
          </span>
        </>
      ),
      sorter: (a, b) => a.duracao.length - b.duracao.length,
    },
    {
      title: t("Estado"),
      dataIndex: "estado",
      render: (text, record) => (
        <>
          <span
            className={`badge ${
              calculateExpirationInfo(record?.data_expiracao)?.status ==
              "Expirado"
                ? "badge-danger"
                : calculateExpirationInfo(record?.data_expiracao)?.status ==
                  "Prestes a expirar"
                ? "badge-warning"
                : "badge-success"
            }`}
          >
            {calculateExpirationInfo(record?.data_expiracao)?.status}
          </span>
        </>
      ),
      sorter: (a, b) => a.estado.length - b.estado.length,
    },
    {
      title: "Dias para Expirar",
      dataIndex: "designacao",
      render: (text, record) => (
        <>
          {" "}
          {calculateExpirationInfo(record?.data_expiracao)?.status ==
          "Expirado" ? (
            <span className="text-danger">Expirado</span>
          ) : (
            <span>
              {calculateExpirationInfo(record?.data_expiracao)?.daysToExpire}{" "}
              dias
            </span>
          )}
        </>
      ),

      sorter: (a, b) => a.designacao.length - b.designacao.length,
    },
    {
      title: t("Action"),
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <span
              className="dropdown-item"
              title={record?.sigla}
              onClick={() => chamarModalEdit(record)}
            >
              <i className="fa fa-pencil m-r-5" /> {t("Edit")}
            </span>
            <span
              className="dropdown-item"
              title={record?.sigla}
              onClick={() => chamarModalEliminar(record)}
            >
              <i className="fa fa-trash m-r-5" /> {t("Delete")}
            </span>
          </div>
        </div>
      ),
    },
  ];

  const handleExportarCertificadosPDF = async (
    certificados,
    url_root,
    getMissao
  ) => {
    const doc = new jsPDF();
    const today = new Date();

    const calculateExpirationInfo = (expirationDateStr) => {
      const expirationDate = new Date(expirationDateStr);
      const timeDiff = expirationDate.getTime() - today.getTime();
      const daysToExpire = Math.ceil(timeDiff / (1000 * 3600 * 24));

      const status =
        daysToExpire > 0 && daysToExpire <= 90
          ? "Prestes a expirar"
          : daysToExpire > 0
          ? "Valido"
          : "Expirado";

      return { daysToExpire, status };
    };

    const renderPDFContent = (startY) => {
      doc.setFontSize(14);
      doc.text("Relatório de Certificados", 105, startY, { align: "center" });
      doc.setLineWidth(0.5);
      doc.line(10, startY + 5, 200, startY + 5);

      const columns = [
        { header: "Colaborador", dataKey: "colaborador" },
        { header: "Cargo", dataKey: "cargo" },
        { header: "Curso", dataKey: "curso" },
        { header: "Nível", dataKey: "nivel" },
        { header: "Emissão", dataKey: "emissao" },
        { header: "Expiração", dataKey: "expiracao" },
        { header: "Dias", dataKey: "dias" },
        { header: "Estado", dataKey: "estado" },
      ];

      const data = certificados.map((item) => {
        const info = calculateExpirationInfo(item.data_expiracao);
        return {
          colaborador: item?.formando?.name || "",
          cargo: item?.formando?.cargo?.designacao || "",
          curso: item?.curso?.designacao || "",
          nivel:
            item?.curso?.nivel === 1
              ? "Básico"
              : item?.curso?.nivel === 2
              ? "Intermédio"
              : item?.curso?.nivel === 3
              ? "Avançado"
              : "Padrão",
          emissao: new Date(item.data_emissao).toLocaleDateString(),
          expiracao: new Date(item.data_expiracao).toLocaleDateString(),
          dias:
            info.status === "Expirado"
              ? "Expirado"
              : `${info.daysToExpire} dias`,
          estado: info.status,
        };
      });

      autoTable(doc, {
        head: [columns.map((col) => col.header)],
        body: data.map((row) => columns.map((col) => row[col.dataKey])),
        startY: startY + 10,
        styles: { fontSize: 9 },
      });

      doc.save("certificados.pdf");
    };

    // Tentar carregar imagem do logotipo
    try {
      const imageUrl = `${url_root}/storage/${getMissao()?.imagem}`;
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      const reader = new FileReader();
      reader.onloadend = function () {
        const base64data = reader.result;
        doc.addImage(base64data, "JPEG", 10, 10, 30, 20);
        renderPDFContent(38);
      };
      reader.readAsDataURL(blob);
    } catch (error) {
      console.warn("Erro ao carregar imagem, exportando sem logotipo.");
      renderPDFContent(20);
    }
  };

  if (loading)
    return (
      <>
        <Spinner>
          <ToastContainer />
        </Spinner>
      </>
    );
  else
    return (
      <>
        <div className="row">
          <div className="col-md-12">
            <button
              className="btn btn-danger mb-3"
              onClick={() =>
                handleExportarCertificadosPDF(
                  certificado,
                  url_root,
                  getMissao
                )
              }
            >
              <i className="fa fa-file-pdf" /> Exportar PDF
            </button>

            <div className="table-responsive">
              <Table
                className="table-striped"
                style={{ overflowX: "auto" }}
                columns={columns}
                dataSource={certificado}
                rowKey={(record) => record.id}
              />

              <CertificadoEditModal
                onSubmissionSuccess={handleSubmissionSuccess}
                certificado={certificadoselecionado}
              />

              <DeleteModal
                objectoName={t("Registo")}
                onSubmissionSuccess={handleSubmissionSuccess}
                id={certificadoselecionado?.id}
                endpoint={"certificado"}
              />

              <span
                data-bs-toggle="modal"
                data-bs-target="#edit_certificado_modal"
                id="triggerModalEdit"
              ></span>

              <span
                data-bs-toggle="modal"
                data-bs-target="#delete"
                id="triggerModalEliminar"
              ></span>
            </div>
          </div>
        </div>
        <ToastContainer />
      </>
    );
};

export default CertificadoTable;
